import { Lock } from "lucide-react";
import type { FC } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

import { useCase } from "../../contexts/CaseContext";
import { isCaseUnavailable } from "./caseAvailability";
import { CaseIde } from "./CaseIde";
import { useCaseRoute } from "./useCaseRoute";

export { isCaseUnavailable };

/** Route element for `<case root>/workspace`, the case home. */
export const CaseWorkspacePage: FC = () => {
  const { individualId } = useCaseRoute();
  const { case: caseInfo, error } = useCase();
  const navigate = useNavigate();

  if (!individualId) {
    return <Navigate to="/" replace />;
  }
  if (!caseInfo && isCaseUnavailable(error)) {
    return (
      <EmptyState
        icon={Lock}
        title="This Case Isn't Available"
        description="It belongs to another firm, or it was removed. Ask the case's attorney for access if you need it."
        action={
          <Button variant="secondary" onClick={() => navigate("/cases")}>
            Back to Cases
          </Button>
        }
        className="h-full"
        data-testid="case-unavailable"
      />
    );
  }
  return (
    // Keyed by case: no tab, tree, editor or list state survives a switch.
    <CaseIde
      key={individualId}
      individualId={individualId}
      caseId={caseInfo?.case_id ?? null}
    />
  );
};
